import Vue from 'vue';
import Vuex from 'vuex';
import snackbar from '@/store/modules/snackbar';
import registerDashboard from '@/store/modules/dashboard';
import registerDashboardDispatcher from '@/store/modules/dashboardDispatcher';
import boilerplate from './modules/boilerplate';
import global from './modules/global';
import registerDashboardPem from './modules/dashboardPem';
import registerEntities from './modules/entities';
import registerProperties from './modules/properties';
import registerPropertiesIgnitions from './modules/properties/ignitions';
import registerProperties360 from './modules/properties_360';
import registerLogbook from './modules/logbook';
import registerActionPlans from './modules/actionplans';
import registerActions from './modules/actions';
import registerSensors from './modules/sensors';
import registerRequests from './modules/requests';
import registerAlerts from './modules/alerts';
import registerTechnicians from './modules/technicians';
import registerRouteModule from './modules/routeModule';
import registerInstructions from './modules/instructions';
import registerModal from './modules/modal';
import registerAuthorizations from './modules/authorization';
import registerDocuments from './modules/documents';
// import registerRegControls from './modules/regulatoryControls';

Vue.use(Vuex);

const reusable = {
  namespaced: true,
};
const store = new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  modules: {
    boilerplate,
    global,
    reusable,
    snackbar,
  },
});

registerAuthorizations(store);
registerRouteModule(store);
registerProperties(store);
registerPropertiesIgnitions(store);
registerLogbook(store); // register before 360
registerDocuments(store); // register before 360
registerProperties360(store);
registerActionPlans(store);
registerActions(store);
registerRequests(store);
registerAlerts(store);
registerTechnicians(store);
registerInstructions(store);
registerModal(store);
registerSensors(store);
// registerRegControls(store);
registerDashboard(store);
registerDashboardDispatcher(store);
registerDashboardPem(store);

// Entities must be the latest registered
registerEntities(store);
export default store;
